import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { EntityPageContractType } from '@xingternal/pages-graphql-types';
import { PageContext, UpsellBannerWithIcon } from '@xingternal/pages-common';
import { XingFrameContext } from '@xingternal/xing-frame-provider';
import type {
  EntityPageQuery,
  EntitySubpageQuery,
} from '@xingternal/pages-common';
import type { EntityPageCoverImageQueryResult } from './CoverMedia/CoverImageQuery.gql-types';
import Header from './Header';
import HeaderSkeleton from './HeaderSkeleton';
import styles from './Header.css';
import { ENTITY_PAGES_UNFENCE_HEADER } from './Edit/Images/Cover/EditCoverMenu';

type HeaderContainerProps = {
  entityPageData?: EntityPageQuery | EntitySubpageQuery;
  showKununu?: boolean;
  isEditor?: boolean;
  pageSlug: string;
  isPageLoading?: boolean;
  moduleType?: string;
  moduleProperties?: any;
  isSubpage?: boolean;
  isFreePage?: boolean;
  coverMediaQueryResult?: EntityPageCoverImageQueryResult;
};

const HeaderContainer = (props: HeaderContainerProps) => {
  const {
    entityPageData,
    showKununu,
    isEditor,
    pageSlug,
    isPageLoading,
    moduleType,
    moduleProperties,
    isSubpage = false,
    isFreePage,
    coverMediaQueryResult,
  } = props;
  const intl = useIntl();
  const { pageContext } = useContext(PageContext);
  const { featureSwitches } = useContext(XingFrameContext);

  if (
    isPageLoading ||
    entityPageData?.entityPageEX?.__typename !== 'EntityPage'
  ) {
    return <HeaderSkeleton />;
  }

  const hasFenceFS = featureSwitches?.includes(ENTITY_PAGES_UNFENCE_HEADER);
  const isEBP =
    entityPageData.entityPageEX.contract?.type === EntityPageContractType.Paid;

  const headerModuleData =
    'modules' in entityPageData.entityPageEX
      ? entityPageData?.entityPageEX?.modules?.collection[0]
      : undefined;
  const ctaType = moduleProperties?.cta;
  const headerContent =
    headerModuleData &&
    headerModuleData.__typename === 'EntityPageHeaderModule' &&
    headerModuleData?.content
      ? headerModuleData?.content
      : undefined;
  const pageTitle = entityPageData.entityPageEX.title;

  const data = {
    title:
      isSubpage && moduleType
        ? intl.formatMessage({
            id: `EP_${moduleType.toUpperCase()}_DESCRIPTION`,
          })
        : pageTitle,
    subtitle:
      isSubpage || !('slogan' in entityPageData.entityPageEX)
        ? pageTitle
        : isEBP
        ? entityPageData.entityPageEX.slogan
        : null,
    headerContent,
    isPageLoading,
    isFreePage,
    isEditor,
    pageSlug,
    pageId: entityPageData.entityPageEX.id,
    globalId: entityPageData.entityPageEX.globalId,
    pageUrl: entityPageData.entityPageEX.links?.self,
    logo: entityPageData.entityPageEX.logoImage?.[0]?.url,
    socialProof: entityPageData.entityPageEX.userPageContext?.socialProof,
    isFollowingPage:
      (entityPageData.entityPageEX.userPageContext?.userInteractions
        ?.__typename === 'EntityPageUserInteractionFollow' &&
        entityPageData.entityPageEX.userPageContext?.userInteractions
          ?.followState?.isFollowing) ||
      false,
    showKununu,
    isSubpage,
    ctaType,
    coverMediaQueryResult,
  };

  return (
    <>
      {!hasFenceFS && pageContext?.upsellActive && (
        <div className={styles.upsellLayout}>
          <UpsellBannerWithIcon
            headerCopyKey="EP_UPSELL_HEADER_TOP_HEADER"
            bodyCopyKey="EP_UPSELL_BODY_TOP_HEADER"
            moduleName="headermodule"
          />
        </div>
      )}
      <Header {...data} />
    </>
  );
};

export default HeaderContainer;
